import Base from './Base'

class InstrumentAlarmEvent extends Base {
  static className = 'InstrumentAlarmEvent'
  static define() {
    this.belongsTo('instrumentAlarmNote')
    this.hasOne('instrumentAlarm')
    this.hasMany('notifications')
    this.attributes('cause', 'alarmProperties', 'dataAgeSecs', 'dataValues', 'createdAt', 'dataValuesWithRanges')
  }

  static causes = ['value_off_range', 'sensor_muted', 'issues_cleared', 'alarm_on', 'alarm_off', 'outside_geofence', 'low_battery', 'stalled_value']

  static causeToHuman(cause){
    return {
      value_off_range: 'Value off range',
      sensor_muted: 'Muted sensor(s)',
      issues_cleared: 'Issues cleared',
      alarm_on: 'Alarm enabled',
      alarm_off: 'Alarm disabled',
      outside_geofence: 'Outside geofence',
      low_battery: 'Low battery',
      stalled_value: 'Stalling value'
    }[cause]
  }

  causeToHuman(){
    return this.constructor.causeToHuman(this.cause)
  }

  hasDetails(){
    return !this.notifications().empty() || this.instrumentAlarmNote() !== null
  }
}

export default Base.createResource(InstrumentAlarmEvent)